import { render, staticRenderFns } from "./modalAddPushNotification.vue?vue&type=template&id=1b19f2ee&scoped=true&"
import script from "./modalAddPushNotification.vue?vue&type=script&lang=js&"
export * from "./modalAddPushNotification.vue?vue&type=script&lang=js&"
import style0 from "./modalAddPushNotification.vue?vue&type=style&index=0&id=1b19f2ee&scoped=true&lang=css&"
import style1 from "./modalAddPushNotification.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b19f2ee",
  null
  
)

export default component.exports